export default __webpack_public_path__ + "static/media/secure-icon.96a160cf.svg";